import { PERSON_TYPE_STUDENT } from '../../../constants'
import useCurrentUser from '../../queries/currentUser/useCurrentUser'

const useCurrentUserIsStudentSelector = () => useCurrentUser()?.data?.person_type === PERSON_TYPE_STUDENT

export default useCurrentUserIsStudentSelector
